import * as React from "react";
import { Instructor } from "@/common/instructor/types";
import InstructorCard from "./InstructorCard";

interface PartnerInstructorsProps {
  instructors: Instructor[];
  maxDisplay?: number;
  location?: string;
}

const PartnerInstructors = ({
  instructors,
  maxDisplay = 1,
  location,
}: PartnerInstructorsProps) => {
  const sortedInstructors = [...instructors].sort((a, b) => {
    const sortA = a.sortValue ?? Number.MAX_SAFE_INTEGER;
    const sortB = b.sortValue ?? Number.MAX_SAFE_INTEGER;
    return sortA - sortB;
  });
  // Limit to maxDisplay instructors
  const displayInstructors = sortedInstructors.slice(0, maxDisplay);

  // TODO: Need to specify the featured instructor logic.
  // The first instructor (lowest sortValue) is featured
  const featuredInstructorId = displayInstructors[0]?.id;

  if (displayInstructors.length === 0) {
    return null;
  }

  return (
    <div className="container py-8 md:py-12">
      <div className="flex flex-col gap-6">
        {displayInstructors.map((instructor) => (
          <InstructorCard
            key={instructor.id}
            instructor={instructor}
            isFeatured={instructor.id === featuredInstructorId}
            location={location}
          />
        ))}
      </div>
    </div>
  );
};

export default PartnerInstructors;
